import type { RoofShapeQuoteFormInput } from 'app/home/create-quote/forms/property-details/roof-shape/roof-shape.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';
import type { QuoteFormOptionsSelectorState } from 'app/home/global-store/quote-form-options';

export function roofShapeQuoteFormSelector(store: QuoteDraftSelectorState): RoofShapeQuoteFormInput {
  const roofShape = store.roofShape();
  return { roofShape };
}

export function roofShapeQuoteFormOptionsSelector(store: QuoteFormOptionsSelectorState) {
  return store['roof-shape']();
}
